export default function HealthClasses() {
  return [
    { label: "Best", value: "best" },
    { label: "Better", value: "better" },
    { label: "Good", value: "good" },
  ];
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Lists/HealthClasses/AmericoHealthClasses.js